import React from 'react';
import { MapPin, Phone, Mail } from 'lucide-react';
import '../Pages/main.css';

const ContactSection = () => {
  const primaryColor = "#717fe0";

  return (
    <section className="bg0 p-t-100 p-b-100" style={{ overflow: 'hidden' }}>
      <div className="container">

        {/* Title Section */}
        <div className="row p-b-50">
          <div className="col-12 text-center">
            <h3 className="ltext-105 cl2 p-b-10" style={{ fontWeight: 600, textTransform: 'uppercase', letterSpacing: '2px' }}>
              Get In Touch
            </h3>
            <div style={{ width: '50px', height: '3px', background: primaryColor, margin: '0 auto 20px' }}></div>
            <p className="stext-113 cl6 px-3">
              Connect with our specialized desks for trade and support.
            </p>
          </div>
        </div>

        {/* --- Responsive Container --- */}
        <div className="contact-flex-container" style={{
          display: 'flex',
          flexWrap: 'wrap',
          margin: '0 -15px',
          alignItems: 'stretch'
        }}>

          {/* Left: Map */}
          <div
            className="contact-col"
            style={{
              flex: '0 0 50%',
              maxWidth: '50%',
              padding: '0 15px'
            }}
          >
            <div style={{
              border: `1px solid #e6e6e6`,
              height: '100%',
              minHeight: '400px',
            }}>
              <iframe
                title="Google Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d118983.30313010192!2d81.54924209587428!3d21.262453880520443!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a28dda23524283d%3A0xd6e7448e469e7108!2sRaipur%2C%20Chhattisgarh!5e0!3m2!1sen!2sin!4v1712845000000!5m2!1sen!2sin"
                width="100%"
                height="100%"
                style={{ border: 0, display: 'block', minHeight: '400px' }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
          </div>

          {/* Right: Contact Details */}
          <div
            className="contact-col"
            style={{
              flex: '0 0 50%',
              maxWidth: '50%',
              padding: '0 15px'
            }}
          >
            <div className="contact-info-card" style={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              border: '1px solid #e6e6e6',
              backgroundColor: '#fff'
            }}>

              {/* Heading Block */}
              <div className="contact-hero-inner" style={{ marginBottom: '40px' }}>
                <h2 className="contact-title" style={{
                  fontWeight: '800',
                  textTransform: 'uppercase',
                  letterSpacing: '-1px',
                  color: '#222',
                  lineHeight: '1'
                }}>
                  Contact
                </h2>
                <div style={{ width: '40px', height: '4px', background: '#717fe0', marginTop: '15px' }}></div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>

                {/* Location */}
                <div style={{ display: 'flex', alignItems: 'start', gap: '18px' }}>
                  <MapPin size={20} style={{ color: '#717fe0', marginTop: '4px', flexShrink: 0 }} />
                  <div>
                    <p style={{ fontSize: '10px', fontWeight: '900', textTransform: 'uppercase', color: '#94a3b8', letterSpacing: '0.15em', marginBottom: '6px' }}>Office Location</p>
                    <p style={{ fontSize: '14px', fontWeight: '700', textTransform: 'uppercase', color: '#334155', letterSpacing: '0.05em' }}>
                      Raipur, CG, India
                    </p>
                  </div>
                </div>

                {/* Phone */}
                <div style={{ display: 'flex', alignItems: 'start', gap: '18px' }}>
                  <Phone size={20} style={{ color: '#717fe0', marginTop: '4px', flexShrink: 0 }} />
                  <div>
                    <p style={{ fontSize: '10px', fontWeight: '900', textTransform: 'uppercase', color: '#94a3b8', letterSpacing: '0.15em', marginBottom: '6px' }}>Direct Line</p>
                    <p style={{ fontSize: '14px', fontWeight: '700', textTransform: 'uppercase', color: '#334155', letterSpacing: '0.05em' }}>
                      +91 63537 78329
                    </p>
                  </div>
                </div>

                {/* Trade Enquiry */}
                <div style={{ display: 'flex', alignItems: 'start', gap: '18px' }}>
                  <Mail size={20} style={{ color: '#717fe0', marginTop: '4px', flexShrink: 0 }} />
                  <div style={{ overflow: 'hidden' }}>
                    <p style={{ fontSize: '10px', fontWeight: '900', textTransform: 'uppercase', color: '#94a3b8', letterSpacing: '0.15em', marginBottom: '6px' }}>Trade Enquiry</p>
                    <p className="single-line-email" style={{ fontWeight: '700', color: '#334155' }}>
                      trade-enquiry@parekhrayon.com
                    </p>
                  </div>
                </div>

                {/* Customer Care */}
                <div style={{ display: 'flex', alignItems: 'start', gap: '18px' }}>
                  <Mail size={20} style={{ color: '#717fe0', marginTop: '4px', flexShrink: 0 }} />
                  <div style={{ overflow: 'hidden' }}>
                    <p style={{ fontSize: '10px', fontWeight: '900', textTransform: 'uppercase', color: '#94a3b8', letterSpacing: '0.15em', marginBottom: '6px' }}>Customer Care</p>
                    <p className="single-line-email" style={{ fontWeight: '700', color: '#334155' }}>
                      customer-care@parekhrayon.com
                    </p>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

      <style>
        {`
          .contact-info-card {
            padding: 60px 50px;
          }
          .contact-title {
            font-size: 42px;
          }
          
          /* Single Line Email Logic */
          .single-line-email {
            font-size: 14px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis; /* Agar screen bohot hi choti ho toh dots dikhayega bajaye wrap hone ke */
          }

          @media (max-width: 1200px) {
            .single-line-email {
              font-size: 13px;
            }
          }

          @media (max-width: 991px) {
            .contact-info-card {
              padding: 40px 30px;
            }
            .single-line-email {
              font-size: 12px;
            }
          }

          @media (max-width: 768px) {
            .contact-col {
              flex: 0 0 100% !important;
              max-width: 100% !important;
            }
            .contact-col:first-child {
              margin-bottom: 25px;
            }
            .contact-info-card {
              padding: 40px 20px;
            }
            .contact-title {
              font-size: 32px;
            }
            .single-line-email {
              font-size: 14px; /* Mobile par width 100% hai toh font wapas thoda bada kar sakte hain */
              white-space: nowrap;
            }
          }

          @media (max-width: 400px) {
            .single-line-email {
              font-size: 12px; /* Very small phones like iPhone SE */
            }
          }
        `}
      </style>

    </section>
  );
};

export default ContactSection;